//import firebase from "firebase"
//import db from "../../firebase/init"
//import router from "../../router"
import api from '../../api/'

const state = {
  categories: [],
  domains: {}, // Changed from [] to {} - domains should be grouped by category names
  workspaceDomains: [],
  searchDomains: [],
  favourites: [],
  adverts: [],
  recommendeSites: [],
  // Store unsubscribe functions for Firebase listeners
  linksUnsubscribe: null,
  favouritesUnsubscribe: null,
  advertsUnsubscribe: null
}
const getters = {
  getCategories: state => !!state.categories,
  getLinks: state => !!state.domains,
  getTeamsWorkspaceLinks: state => !!state.workspaceDomains,
  getFavourites: state => !!state.favourites,
  getSearchLinks: state => !!state.searchDomains,
  getAdverts: state => !!state.adverts,
  getRecommendeSites: state => state.recommendeSites.length > 0
}

const actions = {
  addFavourite: (state, val) => {
    api.addFavourite(state, val)
  },
  fetchCategories: ({ commit }) => {
    api.fetchCategories({ commit })
  },
  fetchApprovedAdverts: ({ commit, state }, approve) => {
    // Clean up existing listener if it exists
    if (state.advertsUnsubscribe) {
      state.advertsUnsubscribe()
      commit('setAdvertsUnsubscribe', null)
    }

    // Create new listener and store its unsubscribe function
    const unsubscribe = api.fetchApprovedAdverts({ commit }, approve)
    if (unsubscribe) {
      commit('setAdvertsUnsubscribe', unsubscribe)
    }
  },
  fetchLinks: ({ commit, state }) => {
    // Clean up existing listener if it exists
    if (state.linksUnsubscribe) {
      state.linksUnsubscribe()
      commit('setLinksUnsubscribe', null)
    }

    // Create new listener and store its unsubscribe function
    const unsubscribe = api.fetchLinks({ commit })
    if (unsubscribe) {
      commit('setLinksUnsubscribe', unsubscribe)
    }
  },
  fetchTeamsWorkspaceLinks: ({ commit }, group) => {
    api.fetchTeamsWorkspaceLinks({ commit }, group)
  },
  fetchFavourites: ({ commit, state }) => {
    // Clean up existing listener if it exists
    if (state.favouritesUnsubscribe) {
      state.favouritesUnsubscribe()
      commit('setFavouritesUnsubscribe', null)
    }

    // Create new listener and store its unsubscribe function
    const unsubscribe = api.fetchFavourites({ commit })
    if (unsubscribe) {
      commit('setFavouritesUnsubscribe', unsubscribe)
    }
  },
  addLink: ({ commit }, linkData) => {
    return api.addLink(linkData).then(addedLink => {
      commit('ADD_LINK', addedLink)
      return addedLink
    })
  },
  addAdvert: (state, value) => {
    api.addAdvert(state, value)
  },
  updateAdvert: (state, value) => {
    api.updateAdvert(state, value)
  },
  editLink: (state, value) => {
    api.editLink(state, value)
  },
  deleteLink: (state, value) => {
    api.deleteLink(state, value)
  },
  bulkUpdateCategory: (context, { docIds, newCategory }) => {
    return api.bulkUpdateCategory(docIds, newCategory)
  },
  addDomain: (state, domain) => {
    api.insertDomain(state, domain)
  },
  addPost: (state, value) => {
    api.addPost(state, value)
  },
  getPosts: (state, value) => {
    api.getPosts(state, value)
  },
  addFollower: (state, value) => {
    api.addFollower(state, value)
  },
  getFollowers: (state, value) => {
    api.getFollowers(state, value)
  },
  unFollow: (state, value) => {
    api.unFollow(state, value)
  },
  isFollowing: (state, value) => {
    api.isFollowing(state, value)
  },
  setRecommendedSites: ({ commit }, val) => {
    commit('setRecommendedSites', val)
  },
  // Action to clean up all listeners (called on logout)
  cleanupListeners: ({ commit, state }) => {
    if (state.linksUnsubscribe) {
      state.linksUnsubscribe()
      commit('setLinksUnsubscribe', null)
    }
    if (state.favouritesUnsubscribe) {
      state.favouritesUnsubscribe()
      commit('setFavouritesUnsubscribe', null)
    }
    if (state.advertsUnsubscribe) {
      state.advertsUnsubscribe()
      commit('setAdvertsUnsubscribe', null)
    }
    // Clear all data
    commit('setLinks', {}) // Changed from [] to {}
    commit('setFavourites', [])
    commit('setSearchLinks', [])
    commit('setTeamsWorkspaceLinks', [])
    commit('setAdverts', [])
  }
}

const mutations = {
  setCategories: (state, categories) => {
    state.categories = categories
  },
  setLinks: (state, domains) => {
    state.domains = domains
  },
  setTeamsWorkspaceLinks: (state, workspaceDomains) => {
    state.workspaceDomains = workspaceDomains
  },
  setSearchLinks: (state, searchDomains) => {
    state.searchDomains = searchDomains
  },
  setFavourites: (state, favourites) => {
    state.favourites = favourites
  },
  setAdverts: (state, adverts) => {
    state.adverts = adverts
  },
  setRecommendedSites: (state, sites) => {
    state.recommendeSites = sites
  },
  ADD_LINK(state, link) {
    // Add the link to your state
    // This depends on how your state is structured
    if (!state.domains[link.domain]) {
      state.domains[link.domain] = []
    }
    state.domains[link.domain].push(link)
  },
  setLinksUnsubscribe(state, unsubscribe) {
    state.linksUnsubscribe = unsubscribe
  },
  setFavouritesUnsubscribe(state, unsubscribe) {
    state.favouritesUnsubscribe = unsubscribe
  },
  setAdvertsUnsubscribe(state, unsubscribe) {
    state.advertsUnsubscribe = unsubscribe
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
